import React from "react";

import clsx from "clsx";
import { twMerge } from "tailwind-merge";

interface Props {
  value: number;
  isPositiveChangeGood: boolean;
  size?: "lg" | "md" | "sm";
  className?: string;
}

export const ChangePill = ({
  value,
  isPositiveChangeGood,
  size = "lg",
  className,
}: Props) => {
  const normalizedValue = isNaN(value) ? 0 : value;
  const formatted =
    Math.abs(normalizedValue) >= 1e9 // 1 billion
      ? "∞"
      : (Math.abs(normalizedValue) * 100).toFixed(2);

  return (
    <span
      className={twMerge(
        "inline-block rounded-xl align-middle",
        clsx({
          "text-xs px-2 font-bold leading-6": size === "lg",
          "text-[11px] px-1 leading-5": size === "md",
          "text-xxs px-2 leading-5": size === "sm",
          "bg-highlight text-v2-secondary": normalizedValue === 0,
          "bg-v2-highlight-notice text-v2-action-positive":
            (isPositiveChangeGood && normalizedValue > 0) ||
            (!isPositiveChangeGood && normalizedValue < 0),
          "bg-v2-highlight-alert text-v2-action-negative":
            (isPositiveChangeGood && normalizedValue < 0) ||
            (!isPositiveChangeGood && normalizedValue > 0),
        }),
        className,
      )}
    >
      <i
        className={clsx("fa-regular fa-sharp mr-0.5", {
          "text-[10px]": size === "md",
          "text-[9px]": size === "sm",
          "fa-arrow-up": normalizedValue > 0,
          "fa-arrow-down": normalizedValue < 0,
        })}
      ></i>
      {formatted}%
    </span>
  );
};
